import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DoubleTick from './icon-double-tick.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DoubleTick {...validProps} />;
}
SvgComponent.iconName = 'double-tick';

/**
 * @deprecated This is a legacy icon
 */
export const DoubleTickIcon = svgIconWrapper(SvgComponent);
